// extracted by mini-css-extract-plugin
export var active = "_ag-a";
export var activeIndicator = "_ag-8";
export var animate = "_ag-9";
export var disabled = "_ag-b";
export var fullWidth = "_ag-2";
export var lg = "_ag-7";
export var md = "_ag-6";
export var redoButtonTabGroup = "_ag-0";
export var sm = "_ag-5";
export var tabButton = "_ag-3";
export var tabButtonsContainer = "_ag-1";
export var xs = "_ag-4";